import { Pipe, PipeTransform } from '@angular/core';
import { AttributeBase, ForwardPointsField, sideValue } from '@approot/models';
import { getDecimalPlaces } from '@approot/widgets/strategy-detail/leg/utilities/leg.utilities';

@Pipe({
  name: 'forwardPointsFormatter',
  standalone: false
})
export class ForwardPointsFormatterPipe implements PipeTransform {
  transform(
    value: sideValue,
    ctrlName: ForwardPointsField,
    attributesAsFormControls: AttributeBase<any>[]
  ): string {
    if (value === '' || value == null) {
      return '';
    }

    return value.toFixed(getDecimalPlaces(ctrlName, attributesAsFormControls));
  }
}
